import { Button, ControlGroup, InputGroup } from "@blueprintjs/core"
import CustomFormGroup from "components/Atoms/CustomFormGroup"
import { useAddUpdateBeatRemarkMutation } from "generated/graphql"
import React, { useEffect, useState } from "react"
import AppToaster from "utils/AppToaster"

const AddRemark = ({ remark, beatId }) => {
  const [value, setValue] = useState(remark)
  const [mutate, { loading }] = useAddUpdateBeatRemarkMutation({
    onCompleted() {
      AppToaster.show({
        message: "Remark added successfully",
        intent: "success",
      })
    },
    onError() {
      AppToaster.show({
        message: "Unable to add the remark",
        intent: "danger",
      })
    },
  })

  useEffect(() => {
    setValue(remark)
  }, [remark, setValue])
  return (
    <CustomFormGroup label="Remark" big={false}>
      <ControlGroup>
        <InputGroup
          value={value}
          onChange={e => setValue(e.target.value)}
          leftIcon="paragraph"
          placeholder="Please enter a remark"
        />
        <Button
          intent="success"
          icon="endorsed"
          text="Save"
          loading={loading}
          onClick={() => {
            if (value.length < 4) {
              return AppToaster.show({
                message: "Remark must be at least 4 characters long",
                intent: "danger",
              })
            }

            mutate({
              variables: {
                id: beatId,
                remark: value,
              },
            })
          }}
        />
      </ControlGroup>
    </CustomFormGroup>
  )
}

export default AddRemark
